import { render, staticRenderFns } from "./CancellationWorkflow.vue?vue&type=template&id=a7d23d36&scoped=true"
import script from "./CancellationWorkflow.vue?vue&type=script&lang=ts"
export * from "./CancellationWorkflow.vue?vue&type=script&lang=ts"
import style0 from "./CancellationWorkflow.vue?vue&type=style&index=0&id=a7d23d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d23d36",
  null
  
)

export default component.exports